import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ServicecallService } from 'src/app';
import { EntitiesServiceService } from 'src/app/shared/services';

@Component({
  selector: 'app-telemetry-data',
  templateUrl: './telemetry-data.component.html',
  styleUrl: './telemetry-data.component.css'
})
export class TelemetryDataComponent implements OnInit, OnDestroy {

  @Input() entityData;
  @Input() fromDate: any;
  @Input() toDate: any;
  private _getEntityDataSubscription: Subscription;
  private _dynamicEntityData: any = [];
  public masterAttributeList: any = [];
  private _startTime: Date = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate(),
    0,
    0,
    0,
    999
  );

  constructor(private _sharedService: ServicecallService, private _service: EntitiesServiceService, private _datePipe: DatePipe) { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    if (this.entityData?._id) {
      this._getEntitiesData();
    }
  }

  ngOnDestroy(): void {
    this._getEntityDataSubscription?.unsubscribe();
  }

  /**
   * Getattributes telemetry data component
   * @returns  
   */
  private _getattributes() {
    return this._sharedService.getConfigurationBasedOnCategory(
      this.entityData
    )
      ? this._sharedService.getConfigurationBasedOnCategory(this.entityData)
        .telemetryDataAttributes
      : [];
  }

  /**
   * Gets entities data
   */
  private _getEntitiesData() {
    let configStartDate = null;
    let configEndDate = null;

    if (this._sharedService.getConfiguration('tenantGenericConfig')?.defaultTimeRange) {
      const configHour = this._sharedService.getConfiguration('tenantGenericConfig')?.defaultTimeRange || 0;

      const { startDate, endDate } = this._sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    const reqData = {
      from: this._datePipe.transform(this.fromDate ?? (configStartDate ?? this._startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.toDate ?? (configEndDate ?? Date.now()), 'yyyy-MM-ddTHH:mm:ssZZ'),
      siteId: this._sharedService.getSiteId(),
      entityId: this.entityData?._id,
      entityCategory: this.entityData?.category,
      attributes: this._getattributes()?.map((elem: any) => elem.name)
        ?.length
        ? this._getattributes()?.map((elem: any) => elem.name)
        : undefined,
    };
    this._getEntityDataSubscription = this._service
      .getEntityData(reqData)
      .subscribe({
        next: (result: any) => {
          if (result['status']) {
            if (result['response']['data']) {
              this._dynamicEntityData = [];
              this._dynamicEntityData = this._getattributes();
              if (result['response']['data']?.length) {
                [...result['response']['data'][0]?.attributes].forEach(
                  (elem: any) => {
                    const attIndex = this._dynamicEntityData?.findIndex(
                      (item: any) => item?.name === elem?.attributeName
                    );
                    this._dynamicEntityData[attIndex] = elem;
                    this._dynamicEntityData[attIndex]['uom'] =
                      this._getattributes()?.[attIndex]?.uom;
                    this._dynamicEntityData[attIndex]['attributeName'] =
                      this._getattributes()?.[attIndex]?.attributeName;
                    this._dynamicEntityData[attIndex]['name'] =
                      this._getattributes()?.[attIndex]?.name;
                    if (this._getattributes()?.[attIndex]?.attributeValue) {
                      this._dynamicEntityData[attIndex]['attributeValue'] =
                        this._getattributes()?.[attIndex]?.attributeValue;
                    }
                  }
                );
              }
              // this._dynamicEntityData.map(
              //   (attr: any) =>
              //     (attr['attributeName'] = attr['name'] ? attr['name'] : '')
              // );
            } else {
              this._dynamicEntityData = [];
            }
          } else {
            this._dynamicEntityData = [];
          }
          this.masterAttributeList = [];
          this.masterAttributeList = this._dynamicEntityData;
        },
        error: (error) => {
          if (error) {
            this.masterAttributeList = [];
            this.masterAttributeList = this._dynamicEntityData;
          }
        },
      });
  }
}
